import { render, staticRenderFns } from "./basic-videopicstext-swiper-new-zhijia.vue?vue&type=template&id=4f91a50e&scoped=true&"
import script from "./basic-videopicstext-swiper-new-zhijia.vue?vue&type=script&lang=js&"
export * from "./basic-videopicstext-swiper-new-zhijia.vue?vue&type=script&lang=js&"
import style0 from "./basic-videopicstext-swiper-new-zhijia.vue?vue&type=style&index=0&id=4f91a50e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f91a50e",
  null
  
)

export default component.exports